<template>
  <div class="author-wrapper position-relative">
    创作者专题页
    <div class=" position-absolute w-100 p-4 bottom-0">
      <el-button type="primary" class=" w-100" round @click="goApply">立即报名</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    goApply () {
      this.$router.push({name: 'author_apply'})
    }
  }
}
</script>
<style lang="scss" scoped>
.author-wrapper{
  max-width: 750px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;

}
</style>